export default {"src":"/_next/static/media/emi_calculator.10e84912.svg","height":100,"width":104,"blurWidth":0,"blurHeight":0};